import React from 'react';
import { get, debounce } from 'lodash';
import axios from 'axios';
import { Form } from 'informed';
import { withRouter } from 'react-router-dom';
import FormContainer from '../../containers/Form';
import { Item as defaults } from '../../reducers/defaults';
import { BaseForm } from '../../base';
import { InputSelect, InputText, InputCheckbox, InputSelectAsyncCreatable } from '../../components/inputs';
import { API_HOST } from '../../consts';
import Loading from '../../components/Loading';
import { TrackGoogleAnalyticsEvent } from '../../utils/googleAnalytics';
import {ClickFonteObject, ClickFonteObjectAction} from '../../utils/googleAnalytics/events/Itens/EventFontObject';

const fonteOptions = [
  {
    label: 'Não sou autor do objeto de aprendizagem',
    value: false,
  },
  {
    label: 'Sou autor do objeto de aprendizagem',
    value: true,
  },
];

class Fonte extends BaseForm {
  static defaultProps = {
    fonte: defaults.fonte,
  };

  constructor(props) {
    super(props);
    this.onValueChange = this.onValueChange.bind(this);
    this.callApi = false;
    this.onSubmit = this.onSubmit.bind(this);
    this.fields = [
      'criado_pelo_autor',
      'autor',
      'exame_fonte',
      'ano',
      'publico'
    ];
  }

  metadataModels = ['item']

  state = {
    exame: [],
    save: this.ATUALIZADO,
    fetchingData: true,
  }

  componentDidMount() {
    this.fetchApi('exame', 'core');
    Promise.all([
      this.fetchData(),
      this.fetchMetadata(),
    ])
  }

  fetchData() {
    if (this.id !== 'new') {
      return axios.get(`${API_HOST}/itens/item/${this.id}/form`)
        .then((response) => {
          this.setState({ fetchingData: false }, () => {
            this.setFields(response.data);
            this.callApi = true;
          });
          return response.data;
        });
    }

    return null;
  }

  onValueChange = debounce((values) => {
    this.setState({ save: this.SALVANDO });

    const data = this.getSubmitData(values);

    axios.patch(`${API_HOST}/itens/item/${this.id}`, data)
      .then(() => {
        this.setState({ save: this.SALVO });
      })
      .catch(() => {
        this.setState({ save: this.ERRO });
      });
  }, 500)

  analytcsClick = (name, type) => {
    let label = "Click" + ": " + name;
    let category = ClickFonteObject + "_" + type;

    TrackGoogleAnalyticsEvent(
      category,
      ClickFonteObjectAction,
      label,
    );
  };

  analytcsWrite = (name, type) => {
    let label = "Write" + ": " + name
    let category = ClickFonteObject + "_" + type;

    TrackGoogleAnalyticsEvent(
      category,
      ClickFonteObjectAction,
      label,
    );
  }

  renderForm(isDisabled) {
    const criado_pelo_autor = get(this.state, 'formState.values.criado_pelo_autor');
    const { exame } = this.state;

    if (criado_pelo_autor === false) {
      return (
        <div className="row">
          {this.shouldDisplay('item.autor') && (
            <InputText
              disabled={isDisabled}
              required={this.isRequired('item.autor')}
              col="col-sm-5"
              label="Autor"
              field="autor"
              onBlur={(e)=>{
                if(e.target.value){
                  this.analytcsWrite(`Autor: ${e.target.value}`, "InputText: Autor Writed Value")
                }
                else{
                  this.analytcsWrite(`Autor: Excluído`, "InputText: Autor Writed Value")
                }
              }}
            />
          )}
          {this.shouldDisplay('item.ano') && (
            <InputText
              disabled={isDisabled}
              required={this.isRequired('item.ano')}
              col="col-sm-5"
              label="Ano"
              field="ano"
              onBlur={(e)=>{
                if(e.target.value){
                  this.analytcsWrite(`Ano: ${e.target.value}`, "InputText: Ano Writed Value")
                }
                else{
                  this.analytcsWrite(`Ano: Excluído`, "InputText: Ano Writed Value")
                }
              }}
            />
          )}
        </div>
      );
    }


    return null;
  }

  onSubmit(url) {
    axios.get(`${API_HOST}/itens/item/${this.id}/validate?form=fonte`)
      .then(() => {
        const { history } = this.props;
        history.push(`/itens/${this.id}/${url}`);
      })
      .catch((error) => {
        this.onValidateError(error, 'fonte');
      });
  }

  render() {
    const { fetchingData, save } = this.state;
    const { isDisabled } = this.props;
    return (
      <FormContainer
        title="Fonte"
        next="pendencias"
        previous="conteudo"
        onClick={this.onSubmit}
        disabled={save === this.MODIFICADO}
      >
        <Form
          onChange={formState => this.setState({ formState })}
          onValueChange={(values) => {
            if (this.callApi) {
              this.setState({ save: this.MODIFICADO });
              this.onValueChange(values);
            }
          }}
          getApi={(formApi) => { this.formApi = formApi; }}
        >
          {() => {
            if (fetchingData) {
              return <Loading />;
            }

            return (
              <React.Fragment>
                {this.renderSaveStatus()}
                <div className="row">
                  <InputSelect
                    disabled={isDisabled}
                    col="col-sm-4"
                    value = {get(this.state, 'formState.values.criado_pelo_autor')}
                    label="Fonte da questão"
                    field="criado_pelo_autor"
                    options={fonteOptions}
                    onChange={(e)=>{
                      if(e){
                        this.analytcsClick(`Fonte da questão: ${e.label}`, "InputSelect: Fonte da questão Clickd Value")
                      }
                      else{
                        this.analytcsClick(`Fonte da questão: Excluído`, "InputSelect: Fonte da questão Remove Value")
                      }
                    }}
                  />
                </div>

                {this.renderForm(isDisabled)}

              </React.Fragment>
            );
          }}
        </Form>
      </FormContainer>
    );
  }
}

export default withRouter(Fonte);
